import React, { useState, useEffect } from 'react';

import { SingleButton, CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';
import { getval2Token, getUserInfoCompanyId, setVal2Token } from '../../../Login/Auth';
import { SingleText, SingleSelect } from '../../Res/BaseInput';
import moment from 'moment';
import { contractorAttendanceStatusAttr_Edit, ReqContractorAttendanceDetail, ReqContractorAttendance, ReqContractorAttendanceSOPCount } from '../../../../item/ItemContractorAttendance';
import { api_getContractorAttendanceDetail, api_updateContractorAttendanceSOPStatus } from '../../../../api/apiContractorAttendancee';
import { ContractorAttendanceEditSalaryMonthly } from './ContractorAttendanceEditSalaryMonthly';
import { ContractorAttendanceEditSalaryHourly } from './ContractorAttendanceEditSalaryHourly';
import { ContractorAttendanceEditBonus } from './ContractorAttendanceEditBonus';


export function ContractorAttendanceEdit({ id, setIsLoading }) {
  const [tokenId, setTokenId] = useState("")

  const [companyId] = useState(getUserInfoCompanyId())
  const [contractorAttendanceId, setContractorAttendanceId] = useState("")
  const [customerContractId, setCustomerContractId] = useState("")
  const [contractorAttendanceSOPName, setContractorAttendanceSOPName] = useState("")
  const [creatAt, setCreatAt] = useState("")
  const [creatName, setCreatName] = useState("")
  const [contractorAttendance, setContractorAttendance] = useState({})
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [dates, setDates] = useState("")
  const [contractorAttendanceSOPStatus, setContractorAttendanceSOPStatus] = useState("")

  const [salaryMonthly, setSalaryMonthly] = useState(undefined)
  const [salaryHourly, setSalaryHourly] = useState(undefined)
  const [bonus, setBonus] = useState(undefined)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      setTokenId(id)
      var obj = getval2Token("contractorAttendanceId", id)
      console.log(obj)
      var contractorAttendance = obj.contractorAttendance
      setContractorAttendanceId(contractorAttendance.contractorAttendanceId)
      setCustomerContractId(contractorAttendance.customerContractId)
      setContractorAttendanceSOPName(contractorAttendance.contractorAttendanceSOPName)
      setCreatAt(moment(contractorAttendance.creatAt).format('YYYY/MM/DD HH:mm:ss'))
      setContractorAttendanceSOPStatus(contractorAttendance.contractorAttendanceSOPStatus)
    }
  }, [id])

  useEffect(() => {
    if (contractorAttendanceId !== "") {
      var mReqContractorAttendanceDetail = new ReqContractorAttendanceDetail({
        companyId,
        contractorAttendanceId
      })
      getContractorAttendanceDetail(mReqContractorAttendanceDetail)
    }
  }, [contractorAttendanceId])

  useEffect(()=>{
    console.log(contractorAttendanceSOPStatus)
  },[contractorAttendanceSOPStatus])

  function getContractorAttendanceDetail(mReqContractorAttendanceDetail) {
    console.log(mReqContractorAttendanceDetail)
    if (setIsLoading !== undefined)
      setIsLoading(true)
    // console.log(mReqRecruitmentContractorStatusList)
    api_getContractorAttendanceDetail({
      mReqContractorAttendanceDetail,
      success: (obj) => {
        console.log(obj)
        var mReqContractorAttendance = new ReqContractorAttendance({})
        mReqContractorAttendance.fromJson(obj.detail)
        mReqContractorAttendance.setData(obj.detail.creatName)
        setContractorAttendance(mReqContractorAttendance)
        setCreatName(mReqContractorAttendance.creatName)
        setDates(mReqContractorAttendance.dates)
        
        console.log(mReqContractorAttendance)
        setSalaryMonthly(mReqContractorAttendance.info.salaryMonthly)
        setSalaryHourly(mReqContractorAttendance.info.salaryHourly)
        setBonus(mReqContractorAttendance.info.bonus)

        if (setIsLoading !== undefined)
          setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        if (setIsLoading !== undefined)
          setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }


  function toCancel() {
    window.history.back();
  }
  function toSaveStatus() {
    if (setIsLoading !== undefined)
      setIsLoading(true)
    var mReqContractorAttendance = new ReqContractorAttendance({
      companyId,
      contractorAttendanceId,
      contractorAttendanceSOPStatus
    })
    api_updateContractorAttendanceSOPStatus({
      mReqContractorAttendance,
      success: () => {
        var obj = getval2Token("contractorAttendanceId", id)
        var contractorAttendance = obj.contractorAttendance
        contractorAttendance.contractorAttendanceSOPStatus = contractorAttendanceSOPStatus
        setVal2Token('contractorAttendanceId', {contractorAttendance}, tokenId)
        if (setIsLoading !== undefined)
          setIsLoading(false)

      },
      failure: (err) => {
        if (setIsLoading !== undefined)
          setIsLoading(false)
      }
    })
    
  }

  var title = <>作業名稱：
    <span className="text-success">{contractorAttendanceSOPName}&nbsp;</span>
  </>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>招募資訊</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"建立時間"} val={creatAt} />
          <SingleText title={"建立者"} val={creatName} />
          <SingleText title={"起迄期間"} val={dates} />
          <SingleSelect title={"作業狀態"}
            val={contractorAttendanceSOPStatus}
            attr={contractorAttendanceStatusAttr_Edit}
            action={setContractorAttendanceSOPStatus}
            hasBlank={false}
            size={3}
          />
        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelName={"返回"} cancelAction={toCancel} submitName={"儲存"} submitAction={toSaveStatus} isRight={true} />
      </div>
    </div>


  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
      {salaryMonthly === undefined ? <></> :
        <ContractorAttendanceEditSalaryMonthly contractorAttendance={contractorAttendance} salaryMonthly={salaryMonthly} />
      }
      {salaryHourly === undefined ? <></> :
        <ContractorAttendanceEditSalaryHourly contractorAttendance={contractorAttendance} salaryHourly={salaryHourly} />
      }
      {bonus === undefined ? <></> :
        <ContractorAttendanceEditBonus contractorAttendance={contractorAttendance} bonus={bonus} />
      }
      
    </>
  )
}